export const baseURL = "https://elmanor.teztour.by/";
export const apiPath = "api.php";
